import { ReactElement, createContext } from "react";
import { Outlet } from "react-router-dom";
import UserProfile from "../components/UserProfile/UserProfile";
export const userRoutes = [
{
  id: 2,
  label: "Calendar",
  path: "",
  profileID: 0,
  component: <div></div>,
},
];
export const empRoutes = [
  {
    id: 2,
    label: "Calendar",
    path: "",
    profileID: 0,
    component: <div></div>,
  },
];
export const UserDataContext = createContext({});
const UserRoute = (props: any): ReactElement => {
  const data = props.loginData;  
  return (
    <UserDataContext.Provider value={data}>
    <UserProfile userData={data}  {...props}>
      <Outlet />      
    </UserProfile>
    </UserDataContext.Provider>
  );
};
export default UserRoute;
